{
  "name": "@uppy/redux-dev-tools",
  "description": "Redux developer tools plugin for Uppy that simply syncs Uppy’s state with redux-devtools browser or JS extensions, and allows for basic time travel",
  "version": "4.1.3",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "module",
  "keywords": [
    "file uploader",
    "redux",
    "redux-dev-tools",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  }
}
